<template>
  <div class="index">
    <navi :activeIndex="3"></navi>
    <div class="container">
      <div class="c1" v-for="(item, index) in items" :key="index">
        <a class="t1" :href="item.url">{{item.title}}</a>
        <div class="t2">发布日期：{{item.time}}&nbsp&nbsp&nbsp&nbsp<span>来源于：{{item.source}}</span></div>
        <div class="t2 t4">{{item.content}}</div>
        <div class="c2">
          <a class="t3" :href="item.url">继续阅读>></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navi from "./Navi.vue";
export default {
  name: "News",
  components: {
    Navi
  },
  data() {
    return {
      items: [
        {
          url: "https://mp.weixin.qq.com/s/MAiSMsgYB_k6UyhlG_4c0g",
          time: "2019-08-01",
          title: "游仁VR宁德学车中心开业了！",
          source: "游仁VR微信公众号",
          content:
            "天气这么热，室外学车太辛苦，不如来我们这里室内VR学车。不怕晒黑，清凉一夏。VR学车，开得更快，学得更帅！........."
        },
        {
          url: "https://mp.weixin.qq.com/s/9vxBz47Ule-Pu5WzIcYdPA",
          time: "2019-05-23",
          title: "VR学车，学得更快，开得更帅！",
          source: "游仁VR微信公众号",
          content: "厦门游仁拍摄的第一支专业vr学车宣传视频........."
        },
        {
          url:
            "http://epaper.xmnn.cn/xmwb/20190413/201904/t20190413_5269378.htm",
          time: "2019-04-13",
          title: "吴迪炜:将VR技术引入汽车驾训",
          source: "厦门晚报",
          content:
            "将VR(虚拟现实)技术引入汽车驾驶培训，并非吴迪炜的突发奇想。他说，很早之前，VR技术就用于飞行员、宇航员的培训，引入汽车驾驶培训其实是一种很容易联想的方向。只要技术过关，VR驾训可以快速复制........."
        },
        {
          url:
            "http://fjrb.fjsen.com/fjrb/html/2019-03/21/content_1171536.htm?div=-1",
          time: "2019-03-21",
          title: "驾培的VR之变",
          source: "福建日报",
          content:
            "沉寂两年后， “VR 学车”开始重出江湖。两年前，试水者们尝试将驾校训练场搬上 VR设备，以缓解驾培行业场地、成本、效率存在的痛点。然而，技术限制让这样的想象在现实中遭遇阻力。........."
        },
        {
          url: "https://mp.weixin.qq.com/s/jnU2xy4Dxmo8WE0ZE1SHZw",
          time: "2019-01-26",
          title: "室内学车，安全拿证！VR驾校，身边的驾校！",
          source: "游仁VR微信公众号",
          content:
            "想去学车，可是又怕晒成包黑炭……好不容易鼓起勇气去了，那么多学员看着，还被教练骂“笨啊”，好丢人……最害怕的是辛辛苦苦拿到驾照，还是个马路杀手，不敢开上路啊……"
        },
        {
          url: "https://mp.weixin.qq.com/s/D2GE9GasCfNPJpw05OnMcg",
          time: "2019-01-23",
          title: "游仁VR学车喜获阿里巴巴诸神之战省冠军",
          source: "游仁VR微信公众号",
          content:
            "我司出品的游仁VR（虚拟现实）学车平台，能够把VR（虚拟现实）技术应用在学车上，由电脑系统充当教练，并且通过人工智能对数据进行分析，因人而异进行针对性指导。我司VR团队利用VR技术和体感模拟........."
        }
      ]
    };
  },
  created() {},
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.index {
  /* background-color: rgb(43, 43, 51); */
}

.container {
  /* box-shadow: 0px 0px 6px #999; */
  width: 1300px;
  height: 500px;
  margin: 60px auto;
}
.t1 {
  color: #ea6841;
  text-align: left;
  display: block;
  font-size: 36px;
  line-height: 50px;
}
.t2 {
  color: #999;
  text-align: left;
  font-size: 22px;
  line-height: 50px;
}
.t3 {
  color: #ea6841;
  font-size: 22px;
  float: right;
}
.t4 {
  line-height: 36px;
}
.c1 {
  border-bottom: solid 1px #ccc;
  padding: 30px 0px;
}
.c2 {
  height: 20px;
}
@media only screen and (max-width: 800px) {
  .container {
    width: auto;
    margin: 60px 30px;
  }
  .t1 {
    font-size: 28px;
  }
  .t2 {
    font-size: 20px;
  }
  .t2 span {
    margin-top: -15px;
    margin-bottom: 10px;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/News.vue